export default {
  throttle(func, limit) {
    let inThrottle = false;
    return function () {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        return setTimeout(
          () => inThrottle = false,
          limit,
        );
      }
    };
  },
};
